(function () {
  "use strict";

  var lastEventKey = "";
  var lastEventTs = 0;
  var suppressPdpUntil = 0;

  function parseListContext(script) {
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function isDuplicate(itemId) {
    var now = Date.now();
    var key = String(itemId || "");
    if (key === lastEventKey && now - lastEventTs < 2000) return true;
    lastEventKey = key;
    lastEventTs = now;
    return false;
  }

  function isQuickViewClick(target) {
    return !!target.closest(
      "[data-quickshop-full], [data-quickshop-slim], .quickshop-button, .productitem--action.quickshop-button"
    );
  }

  function isExcludedClick(target) {
    return !!target.closest(
      ".productitem--action-atc, [data-product-atc], .productitem--actions .productitem--action-atc, " +
        ".wishlist-engine, .productitem--swatches, [data-swatch-count-wrapper], " +
        ".productitem--compare, .restock-rocket-button, button.restock-rocket-button-collection, " +
        ".productitem--action-trigger.productitem--action-atc, form#adserv"
    );
  }

  function isPdpNavigationClick(target) {
    if (isQuickViewClick(target) || isExcludedClick(target)) return false;

    var card = getProductCard(target);
    if (!card) return false;

    var link = target.closest("a[href]");
    if (!link || !card.contains(link)) return false;

    var href = (link.getAttribute("href") || "").trim();
    if (!href || href === "#" || href.indexOf("javascript:") === 0) return false;

    if (link.hasAttribute("data-product-page-link")) return true;
    if (link.classList.contains("productitem--image-link")) return true;
    if (link.classList.contains("productitem--link")) return true;
    if (link.closest(".productitem--title")) return true;
    if (link.closest(".productitem__image-container, .productitem--image")) return true;

    return false;
  }

  function getProductCard(node) {
    if (!node || !node.closest) return null;
    var card =
      node.closest("[data-product-item]") ||
      node.closest(".productgrid--item");
    if (card) return card;
    var inner = node.closest(".productitem");
    return inner ? inner.closest("[data-product-item], .productgrid--item") || inner : null;
  }

  function findListContextInScope(scope) {
    if (!scope || !scope.querySelector) return null;

    var viewScript = scope.querySelector("[data-ga-view-item-list]");
    var payload = parseListContext(viewScript);
    if (payload) return payload;

    var ctxScript = scope.querySelector("[data-ga-item-list-context]");
    return parseListContext(ctxScript);
  }

  function getListContext(card) {
    var node = card;
    while (node && node !== document.documentElement) {
      var ctx = findListContextInScope(node);
      if (ctx) return ctx;
      node = node.parentElement;
    }

    if (document.body.classList.contains("template-collection")) {
      var titleNode = document.querySelector(".collection--title");
      var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
      return {
        item_list_id: match ? match[1] : "collection",
        item_list_name: titleNode ? titleNode.textContent.trim() : "Collection",
        currency: "AED"
      };
    }

    if (document.body.classList.contains("template-search")) {
      var params = new URLSearchParams(window.location.search);
      var term = (params.get("q") || "").trim();
      return {
        item_list_id: term ? "search_" + term.toLowerCase().replace(/\s+/g, "_") : "search_results",
        item_list_name: term ? "Search: " + term : "Search Results",
        currency: "AED"
      };
    }

    if (document.body.classList.contains("template-product")) {
      var recTitle = document.querySelector(".product-recommendations--title");
      return {
        item_list_id: "related_products",
        item_list_name: recTitle ? recTitle.textContent.trim() : "Related Products",
        currency: "AED"
      };
    }

    if (document.body.classList.contains("template-index")) {
      var sectionTitle = card.closest("section");
      if (sectionTitle) {
        var heading = sectionTitle.querySelector(
          ".featured-collection__title, .product-section--title, h2"
        );
        if (heading) {
          var name = heading.textContent.trim();
          return {
            item_list_id: name.toLowerCase().replace(/\s+/g, "_"),
            item_list_name: name,
            currency: "AED"
          };
        }
      }
    }

    return {
      item_list_id: "product_list",
      item_list_name: document.title || "Products",
      currency: "AED"
    };
  }

  function getItemIndex(card) {
    var list = card.closest(
      ".productgrid--items, .featured-collection__content, [data-content], .search_product, " +
        "[data-product-row], .product-row, .inenrgridpouops"
    );
    if (!list) return 1;

    var items = list.querySelectorAll("[data-product-item], .productgrid--item");
    var cardNode = card.matches("[data-product-item], .productgrid--item")
      ? card
      : card.closest("[data-product-item], .productgrid--item");

    var idx = Array.prototype.indexOf.call(items, cardNode);
    return idx >= 0 ? idx + 1 : 1;
  }

  function hasItemId(item) {
    return !!(item && String(item.item_id || "").trim());
  }

  function resolveItemId(card, link) {
    var id = link ? (link.getAttribute("data-product-id") || "").trim() : "";
    if (id) return id;

    var testfreaks = card.querySelector(".testfreaks-item[data-product-id]");
    if (testfreaks) {
      id = (testfreaks.getAttribute("data-product-id") || "").trim();
      if (id) return id;
    }

    if (link) {
      var href = link.getAttribute("href") || "";
      var handleMatch = href.match(/\/products\/([^/?#]+)/);
      if (handleMatch) return handleMatch[1];
    }

    return "";
  }

  function parseMoney(text) {
    if (!text) return 0;
    var normalized = String(text).replace(/[^0-9.,]/g, "");
    if (!normalized) return 0;
    if (normalized.indexOf(",") > -1 && normalized.indexOf(".") > -1) {
      normalized = normalized.replace(/,/g, "");
    } else if (normalized.indexOf(",") > -1) {
      normalized = normalized.replace(",", ".");
    }
    var value = parseFloat(normalized);
    return isNaN(value) ? 0 : value;
  }

  function readPricingFromCard(card) {
    if (!card) return null;

    var compareEl =
      card.querySelector("[data-price-compare].visible, [data-price-compare]:not(.hidden)") ||
      card.querySelector(".price__compare-at.visible [data-price-compare]") ||
      card.querySelector(".price__compare-at--single[data-price-compare]") ||
      card.querySelector(".original-price");

    var priceEl =
      card.querySelector("[data-price-container] [data-price]") ||
      card.querySelector(".price__current [data-price]") ||
      card.querySelector(".final-price") ||
      card.querySelector(".price__current--emphasize .money");

    var compare = parseMoney(compareEl ? compareEl.textContent : "");
    var price = parseMoney(priceEl ? priceEl.textContent : "");

    if (compare > price && price > 0) {
      return {
        price: price,
        discount: Number((compare - price).toFixed(2))
      };
    }

    return price > 0 ? { price: price, discount: 0 } : null;
  }

  function enrichItemPricing(card, item) {
    if (!item) return item;

    var domPricing = readPricingFromCard(card);
    if (!domPricing) return item;

    if (domPricing.discount > 0) {
      item.price = domPricing.price;
      item.discount = domPricing.discount;
    } else if (!item.price || item.price === 0) {
      item.price = domPricing.price;
    }

    return item;
  }

  function buildItemFromLink(card, link) {
    var pricing = readPricingFromCard(card);
    return {
      item_id: resolveItemId(card, link),
      item_name: (link.getAttribute("data-product-name") || link.textContent || "").trim(),
      item_brand: link.getAttribute("data-product-brand") || "",
      item_category: link.getAttribute("data-product-category") || "",
      item_variant: "",
      price: pricing ? pricing.price : parseFloat(link.getAttribute("data-product-price") || "0") || 0,
      discount: pricing ? pricing.discount : 0,
      currency: "AED"
    };
  }

  function getProductItem(card, listContext) {
    var script = card.querySelector("[data-ga-product-item]");
    var item = null;

    if (script) {
      item = parseListContext(script);
    }

    if (!hasItemId(item)) {
      var link =
        card.querySelector(".productitem--title a") ||
        card.querySelector("a[data-product-page-link]") ||
        card.querySelector("a.productitem--image-link");
      if (link) {
        item = buildItemFromLink(card, link);
      }
    }

    if (listContext && listContext.items && listContext.items.length) {
      var matched = listContext.items.find(function (listItem) {
        return (
          (hasItemId(item) && String(listItem.item_id) === String(item.item_id)) ||
          (item.item_name && listItem.item_name === item.item_name)
        );
      });
      if (matched) {
        item = Object.assign({}, matched, item, {
          item_id: hasItemId(item) ? item.item_id : matched.item_id
        });
      }
    }

    if (!hasItemId(item)) {
      var listIdx = getItemIndex(card) - 1;
      if (listContext && listContext.items && listContext.items[listIdx]) {
        item = Object.assign({}, listContext.items[listIdx]);
      }
    }

    if (!hasItemId(item)) return null;

    item.index = item.index || getItemIndex(card);
    item.currency = item.currency || "AED";
    if (item.discount === undefined || item.discount === null) item.discount = 0;
    item = enrichItemPricing(card, item);

    return item;
  }

  function pushSelectItemDataLayer(listContext, item, viewType) {
    var currency = listContext.currency || item.currency || "AED";

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_id: listContext.item_list_id || "",
        item_list_name: listContext.item_list_name || "",
        currency: currency,
        view_type: viewType,
        items: [
          {
            item_id: String(item.item_id || ""),
            item_name: item.item_name || "",
            item_brand: item.item_brand || "",
            item_category: item.item_category || "",
            item_variant: item.item_variant || "",
            price: Number(item.price) || 0,
            discount: item.discount || 0,
            currency: currency,
            index: Number(item.index) || 1
          }
        ]
      }
    });
  }

  function getProductHandle(card) {
    if (!card) return "";
    var url =
      card.getAttribute("data-product-quickshop-url") ||
      card.getAttribute("data-product-url") ||
      "";
    if (!url) {
      var link =
        card.querySelector("a[href*='/products/']") ||
        card.querySelector(".productitem--title a") ||
        card.querySelector("a.productitem--image-link");
      url = link ? link.getAttribute("href") || "" : "";
    }
    var match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function enrichDiscountFromProductJs(item, handle) {
    if (!item || !handle || Number(item.discount) > 0) {
      return Promise.resolve(item);
    }

    return fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin"
    })
      .then(function (res) {
        if (!res || !res.ok) return null;
        return res.json();
      })
      .then(function (product) {
        if (!product) return item;
        var variants = product.variants || [];
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (
            v &&
            (String(v.sku || "") === String(item.item_id) ||
              String(v.id || "") === String(item.item_id))
          ) {
            variant = v;
            break;
          }
        }
        if (!variant) {
          for (var j = 0; j < variants.length; j++) {
            if (variants[j] && variants[j].available) {
              variant = variants[j];
              break;
            }
          }
        }
        if (!variant) variant = variants[0];
        if (!variant) return item;

        var price = Number(variant.price) || 0;
        var compareAt = Number(variant.compare_at_price) || 0;
        if (compareAt > price) {
          item.price = price / 100;
          item.discount = Number(((compareAt - price) / 100).toFixed(2));
        }
        return item;
      })
      .catch(function () {
        return item;
      });
  }

  // Agency: view_item on Quick View open (view_type Quick_PDP)
  function pushViewItemQuickPdp(item, card) {
    if (!item || !item.item_id) return;

    var dedupeKey = "view_item|" + String(item.item_id);
    var now = Date.now();
    if (
      window.__ga4LastViewItemKey === dedupeKey &&
      now - (window.__ga4LastViewItemTs || 0) < 3000
    ) {
      return;
    }
    window.__ga4LastViewItemKey = dedupeKey;
    window.__ga4LastViewItemTs = now;

    var handle = getProductHandle(card);
    enrichDiscountFromProductJs(Object.assign({}, item), handle).then(function (finalItem) {
      var currency = finalItem.currency || "AED";
      var value = Number(finalItem.price) || 0;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: currency,
          value: value,
          view_type: "Quick_PDP",
          items: [
            {
              item_id: String(finalItem.item_id || ""),
              item_name: finalItem.item_name || "",
              item_brand: finalItem.item_brand || "",
              item_category: finalItem.item_category || "",
              item_variant: finalItem.item_variant || "",
              price: Number(finalItem.price) || 0,
              discount: Number(finalItem.discount) || 0,
              currency: currency
            }
          ]
        }
      });
    });
  }

  function pushSelectItem(viewType, card) {
    if (!window.dataLayer || !card) return;

    var listContext = getListContext(card);
    var item = getProductItem(card, listContext);
    if (!item) return;

    if (isDuplicate(String(item.item_id))) return;

    if (viewType === "Quick_PDP") {
      suppressPdpUntil = Date.now() + 1000;
      pushSelectItemDataLayer(listContext, item, "Quick_PDP");
      pushViewItemQuickPdp(item, card);
    } else if (viewType === "PDP") {
      if (Date.now() < suppressPdpUntil) return;
      pushSelectItemDataLayer(listContext, item, "PDP");
    }
  }

  function onProductInteraction(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (isQuickViewClick(target)) {
      var quickCard = getProductCard(target);
      if (quickCard) pushSelectItem("Quick_PDP", quickCard);
      return;
    }

    if (isPdpNavigationClick(target)) {
      var pdpCard = getProductCard(target);
      if (pdpCard) pushSelectItem("PDP", pdpCard);
    }
  }

  // pointerdown fires before navigation and before empire.js click handlers
  window.addEventListener("pointerdown", onProductInteraction, true);
})();
